import React, { useState } from 'react';

const API = process.env.REACT_APP_SMS_OTP_BASE || 'http://localhost:5000/api/sms-otp';

const SmsOTPStandalone = () => {
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');

  const send = async () => {
    setLoading(true); setMsg('');
    try {
      const r = await fetch(`${API}/send`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ phone }) });
      const j = await r.json();
      if (!j.success) throw new Error(j.error || 'Failed to send');
      setSent(true);
      setMsg('OTP sent.');
    } catch (e) { setMsg(e.message); }
    finally { setLoading(false); }
  };

  const verify = async () => {
    setLoading(true); setMsg('');
    try {
      const r = await fetch(`${API}/verify`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ phone, code }) });
      const j = await r.json();
      if (!j.success) throw new Error(j.error || 'Invalid code');
      setMsg('Verified.');
    } catch (e) { setMsg(e.message); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ maxWidth: 420, margin: '24px auto', padding: 16, border: '1px solid #e5e7eb', borderRadius: 8, background: '#fff' }}>
      <h3 style={{ margin: 0, marginBottom: 12 }}>Standalone SMS OTP (Programmable SMS)</h3>
      {msg && <div style={{ marginBottom: 12, color: msg.includes('Verified') ? '#065f46' : '#b91c1c' }}>{msg}</div>}
      <div style={{ marginBottom: 12 }}>
        <input value={phone} onChange={e => setPhone(e.target.value)} placeholder="+919876543210" style={{ width: '100%', padding: 10, border: '1px solid #d1d5db', borderRadius: 6 }} />
      </div>
      {!sent ? (
        <button disabled={loading || !phone} onClick={send} style={{ padding: '10px 16px', background: '#4f46e5', color: '#fff', border: 0, borderRadius: 6, cursor: 'pointer' }}>{loading ? 'Sending...' : 'Send OTP'}</button>
      ) : (
        <div>
          <div style={{ margin: '12px 0' }}>
            <input value={code} onChange={e => setCode(e.target.value)} placeholder="Enter 6-digit code" style={{ width: '100%', padding: 10, border: '1px solid #d1d5db', borderRadius: 6 }} />
          </div>
          <button disabled={loading || code.length !== 6} onClick={verify} style={{ padding: '10px 16px', background: '#10b981', color: '#fff', border: 0, borderRadius: 6, cursor: 'pointer' }}>{loading ? 'Verifying...' : 'Verify'}</button>
        </div>
      )}
    </div>
  );
};

export default SmsOTPStandalone;


